// Original elimination puzzle. Not affiliated with any published book.

const TITLE = "The Glassworks Folder";
const DEK = "Ellen Voss is in custody. The folder says otherwise.";

const LAYOUT = {
  rows: 40,
  cols: 4,
  pages: 18,
  pagesPerSection: 2,
  nameSize: 10,
  leading: 16,
  colGap: 10,
  pageWidth: 595.28,
  pageHeight: 841.89,
};

LAYOUT.margin = (12 / 25.4) * 72;
LAYOUT.perPage = LAYOUT.rows * LAYOUT.cols;
LAYOUT.total = LAYOUT.perPage * LAYOUT.pages;
LAYOUT.colWidth =
  (LAYOUT.pageWidth - 2 * LAYOUT.margin - (LAYOUT.cols - 1) * LAYOUT.colGap) /
  LAYOUT.cols;
LAYOUT.halfRows = LAYOUT.rows / 2;

const SECTIONS = [
  "North Wharf",
  "Index of Shifts",
  "Harbour Lane",
  "Second Ledger",
  "Old Custom House",
  "Night Notes",
  "Mill Street",
  "Glassworks Yard",
  "Closing Pages",
];

const FIRST = [
  "Agnes", "Alan", "Alma", "Amos", "Andre", "Anita", "Ansel", "April", "Archie", "Arlo",
  "Bea", "Ben", "Bess", "Blake", "Bram", "Bridie", "Bruno", "Bryn",
  "Caleb", "Callum", "Carla", "Carmen", "Cecil", "Celia", "Clark", "Cleo", "Clive", "Cora", "Cosmo", "Crispin",
  "Dale", "Damon", "Dana", "Darcy", "Dean", "Delia", "Denis", "Dolly", "Dora", "Duncan",
  "Eden", "Edith", "Edwin", "Effie", "Elio", "Elsa", "Emil", "Enid", "Erich", "Esther",
  "Farah", "Felix", "Fern", "Fiona", "Floyd", "Frances", "Frank", "Freya",
  "Gareth", "Gemma", "Giles", "Glen", "Grace", "Grant", "Greta", "Gus",
  "Hana", "Hank", "Harris", "Hazel", "Heath", "Hedy", "Helen", "Henry", "Hester", "Holly", "Hugh", "Hugo",
  "Ida", "Idris", "Imogen", "Ines", "Ira", "Ivan", "Ivo",
  "Jade", "James", "Jane", "Jasper", "Jean", "Jesse", "Joan", "Jonah", "Joyce", "Jules", "June",
  "Karl", "Kat", "Keir", "Ken", "Kira", "Kit", "Klaus",
  "Lana", "Larry", "Laura", "Leah", "Lee", "Leif", "Lena", "Leo", "Leon", "Lila", "Lois", "Lorna", "Lucy", "Luke",
  "Mabel", "Mae", "Malcolm", "Mara", "Marc", "Margot", "Mark", "Martha", "Mateo", "Maud", "Miles", "Mira", "Molly", "Morris",
  "Nadia", "Nan", "Naomi", "Ned", "Nell", "Nia", "Nina", "Noel", "Nora",
  "Omar", "Opal", "Orla", "Oscar", "Otis", "Otto",
  "Pam", "Pat", "Paul", "Pearl", "Peggy", "Percy", "Petra", "Philip", "Pia", "Polly",
  "Quentin", "Quinn",
  "Ralph", "Ramon", "Reba", "Remy", "Rene", "Rhea", "Rhys", "Rita", "Rob", "Rosa", "Rose", "Roy", "Ruby", "Ruth",
  "Sam", "Samir", "Saul", "Selma", "Seth", "Shira", "Silas", "Simone", "Sol", "Sonia", "Steve", "Sue", "Sybil",
  "Tamsin", "Ted", "Tess", "Theo", "Thomas", "Tilda", "Toby", "Tom", "Trudy",
  "Una", "Uri", "Ursula",
  "Vera", "Vern", "Victor", "Vida", "Vince", "Viola",
  "Walt", "Wanda", "Warren", "Wes", "Willa", "Will", "Wren",
  "Yves", "Yvonne",
  "Zara", "Zed", "Zora",
];

const LAST = [
  "Adler", "Alam", "Ash", "Atkins", "Bauer", "Beck", "Bell", "Berg", "Birch", "Bloom", "Boyle", "Brandt", "Briggs", "Brook", "Burns",
  "Cade", "Calder", "Carr", "Cho", "Clark", "Cobb", "Cole", "Crowe", "Dahl", "Dean", "Doyle", "Dunn",
  "Egan", "Ellis", "Engel", "Estes",
  "Falk", "Ferris", "Finch", "Ford", "Frost",
  "Gable", "Garza", "Gibbs", "Gill", "Glen", "Gould", "Grant", "Gray", "Grove",
  "Hale", "Hamm", "Hardy", "Hart", "Hayes", "Hess", "Hill", "Holm", "Hook", "Hurst",
  "Ibarra", "Ingram",
  "Jensen", "Judd",
  "Kade", "Kane", "Kay", "Kemp", "Kerr", "King", "Knox", "Kohl", "Kroft",
  "Lang", "Lasky", "Leach", "Lind", "Locke", "Long", "Lund",
  "Macy", "Marsh", "Mead", "Melo", "Mills", "Moon", "Moss", "Muir",
  "Nash", "Ng", "Noll", "North",
  "Oak", "Ortega", "Owen",
  "Page", "Park", "Peck", "Pell", "Pike", "Pohl", "Pratt",
  "Quill", "Quinn",
  "Raff", "Reed", "Reyes", "Rhodes", "Rios", "Roth", "Rowe",
  "Sands", "Sato", "Shah", "Shaw", "Silva", "Snow", "Soto", "Stein",
  "Taft", "Tang", "Teel", "Thorne", "Todd", "Tran", "Truitt",
  "Unger", "Upton",
  "Vale", "Voss", "Wade", "Walsh", "Webb", "West", "Witt", "Wood", "Wynn",
  "Yates", "York",
  "Zahn",
];

const HELV = {
  " ": 278, "!": 278, '"': 355, "#": 556, "$": 556, "%": 889, "&": 667, "'": 191,
  "(": 333, ")": 333, "*": 389, "+": 584, ",": 278, "-": 333, ".": 278, "/": 278,
  "0": 556, "1": 556, "2": 556, "3": 556, "4": 556, "5": 556, "6": 556, "7": 556, "8": 556, "9": 556,
  ":": 278, ";": 278, "<": 584, "=": 584, ">": 584, "?": 556, "@": 1015,
  A: 667, B: 667, C: 722, D: 722, E: 667, F: 611, G: 778, H: 722, I: 278, J: 500,
  K: 667, L: 556, M: 833, N: 722, O: 778, P: 667, Q: 778, R: 722, S: 667, T: 611,
  U: 722, V: 667, W: 944, X: 667, Y: 667, Z: 611,
  a: 556, b: 556, c: 500, d: 556, e: 556, f: 278, g: 556, h: 556, i: 222, j: 222,
  k: 500, l: 222, m: 833, n: 556, o: 556, p: 556, q: 556, r: 333, s: 500, t: 278,
  u: 556, v: 500, w: 722, x: 500, y: 500, z: 500,
};

function mulberry32(seed) {
  let a = seed >>> 0;
  return function rng() {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function shuffle(list, rng) {
  for (let i = list.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    const swap = list[i];
    list[i] = list[j];
    list[j] = swap;
  }
  return list;
}

function widthOf(text, size) {
  let units = 0;
  for (const ch of text) {
    const w = HELV[ch];
    if (w == null) throw new Error("No width for character: " + ch);
    units += w;
  }
  return (units / 1000) * size;
}

function wrapLines(text, size, maxWidth) {
  const words = String(text).split(/\s+/).filter(Boolean);
  const lines = [];
  let line = "";
  for (const word of words) {
    const trial = line ? line + " " + word : word;
    if (widthOf(trial, size) <= maxWidth) line = trial;
    else {
      if (line) lines.push(line);
      line = word;
    }
  }
  if (line) lines.push(line);
  return lines;
}

function position(id) {
  const page = Math.floor(id / LAYOUT.perPage) + 1;
  const onPage = id % LAYOUT.perPage;
  const col = Math.floor(onPage / LAYOUT.rows);
  const row = onPage % LAYOUT.rows;
  const chapter = Math.floor((page - 1) / LAYOUT.pagesPerSection);
  return { page, col, row, chapter };
}

function introParagraphs() {
  return [
    "Ellen Voss was arrested for the death at the glassworks. Before they moved her, she wrote to you. The folder from her kitchen holds the works payroll and the night-shift lists. She says the guilty name is in it, and that she is not.",
    "She does not describe a face, a coat, or a weapon. She only describes where the name sits in this folder.",
    `Each folder page has four columns, labelled A, B, C, and D. Read down a column. Each column holds ${LAYOUT.rows} names. The top name is place 1. A line marks the middle of the column. Each section heading covers ${LAYOUT.pagesPerSection} folder pages.`,
    "A later folder page means a higher page number. An earlier folder page means a lower page number. Closer to the top of a column means a smaller place number. Two names can be compared that way even when they sit in different columns.",
    "Cross out every name her note rules out. One name will remain.",
  ];
}

function caseLabel(seed) {
  return (seed >>> 0).toString(16).padStart(8, "0");
}

function columnPhrase(cols) {
  const letters = cols.map((col) => "ABCD"[col]);
  if (letters.length === 1) return "column " + letters[0];
  if (letters.length === 2) return "column " + letters[0] + " or column " + letters[1];
  return "column " + letters.slice(0, -1).join(", column ") + ", or column " + letters[letters.length - 1];
}

function clueText(clue) {
  switch (clue.type) {
    case "parity":
      return clue.even
        ? "The guilty name is on an even-numbered folder page."
        : "The guilty name is on an odd-numbered folder page.";
    case "columns":
      return "The guilty name is in " + columnPhrase(clue.cols) + ".";
    case "pageAfter":
      return "The guilty name is on a later folder page than " + clue.name + ".";
    case "pageBefore":
      return "The guilty name is on an earlier folder page than " + clue.name + ".";
    case "rowHigher":
      return "The guilty name is closer to the top of its column than " + clue.name + " is to the top of theirs.";
    case "rowLower":
      return "The guilty name is closer to the bottom of its column than " + clue.name + " is to the bottom of theirs.";
    case "placeParity":
      return clue.oddPlace
        ? "Counting from the top of its column, the guilty name is in an odd-numbered place."
        : "Counting from the top of its column, the guilty name is in an even-numbered place.";
    default:
      throw new Error("Unknown clue type: " + clue.type);
  }
}

function matches(clue, person) {
  switch (clue.type) {
    case "parity":
      return (person.page % 2 === 0) === clue.even;
    case "columns":
      return clue.cols.includes(person.col);
    case "pageAfter":
      return person.page > clue.page;
    case "pageBefore":
      return person.page < clue.page;
    case "rowHigher":
      return person.row < clue.row;
    case "rowLower":
      return person.row > clue.row;
    case "placeParity":
      return ((person.row + 1) % 2 === 1) === clue.oddPlace;
    default:
      throw new Error("Unknown clue type: " + clue.type);
  }
}

function presentRank(clue) {
  switch (clue.type) {
    case "pageAfter":
      return 10;
    case "pageBefore":
      return 11;
    case "parity":
      return 12;
    case "columns":
      return 20;
    case "rowHigher":
      return 30;
    case "rowLower":
      return 31;
    case "placeParity":
      return 32;
    default:
      return 50;
  }
}

function findPerson(people, pred, killerId) {
  for (const person of people) {
    if (person.id !== killerId && pred(person)) return person;
  }
  throw new Error("Could not find a landmark name");
}

function stamp(clue, killer) {
  clue.text = clueText(clue);
  if (!matches(clue, killer)) throw new Error("Clue misses the guilty name");
  return clue;
}

function pinColumn(killer) {
  const col = killer.col;
  const left = [col, (col + 1) % LAYOUT.cols].sort((a, b) => a - b);
  const right = [col, (col + 2) % LAYOUT.cols].sort((a, b) => a - b);
  return [
    stamp({ type: "columns", cols: left }, killer),
    stamp({ type: "columns", cols: right }, killer),
  ];
}

function pinPage(people, killer) {
  if (killer.page === 1) {
    const mark = findPerson(people, (person) => person.page === 3, killer.id);
    return [
      stamp({ type: "pageBefore", name: mark.name, page: mark.page }, killer),
      stamp({ type: "parity", even: false }, killer),
    ];
  }
  if (killer.page === LAYOUT.pages) {
    const mark = findPerson(people, (person) => person.page === LAYOUT.pages - 2, killer.id);
    return [
      stamp({ type: "pageAfter", name: mark.name, page: mark.page }, killer),
      stamp({ type: "parity", even: true }, killer),
    ];
  }
  const earlier = findPerson(people, (person) => person.page === killer.page - 1, killer.id);
  const later = findPerson(people, (person) => person.page === killer.page + 1, killer.id);
  return [
    stamp({ type: "pageAfter", name: earlier.name, page: earlier.page }, killer),
    stamp({ type: "pageBefore", name: later.name, page: later.page }, killer),
  ];
}

function pinRow(people, killer) {
  if (killer.row === 0) {
    const mark = findPerson(people, (person) => person.row === 2, killer.id);
    return [
      stamp({ type: "rowHigher", name: mark.name, row: mark.row }, killer),
      stamp({ type: "placeParity", oddPlace: true }, killer),
    ];
  }
  if (killer.row === LAYOUT.rows - 1) {
    const mark = findPerson(people, (person) => person.row === LAYOUT.rows - 3, killer.id);
    return [
      stamp({ type: "rowLower", name: mark.name, row: mark.row }, killer),
      stamp({ type: "placeParity", oddPlace: false }, killer),
    ];
  }
  const above = findPerson(people, (person) => person.row === killer.row - 1, killer.id);
  const below = findPerson(people, (person) => person.row === killer.row + 1, killer.id);
  return [
    stamp({ type: "rowLower", name: above.name, row: above.row }, killer),
    stamp({ type: "rowHigher", name: below.name, row: below.row }, killer),
  ];
}

function buildNote(people, killer) {
  return pinPage(people, killer)
    .concat(pinColumn(killer))
    .concat(pinRow(people, killer))
    .sort((a, b) => presentRank(a) - presentRank(b) || a.text.localeCompare(b.text));
}

function hydrateAll(pairs) {
  return pairs.map((pair, id) => ({
    id,
    first: pair[0],
    last: pair[1],
    name: pair[0] + " " + pair[1],
    ...position(id),
  }));
}

function makePeople(rng) {
  const maxWidth = LAYOUT.colWidth - 8;
  const all = [];
  for (const first of FIRST) {
    for (const last of LAST) {
      const name = first + " " + last;
      if (name === "Ellen Voss") continue;
      if (widthOf(name, LAYOUT.nameSize) <= maxWidth) all.push([first, last]);
    }
  }
  if (all.length < LAYOUT.total) {
    throw new Error("Not enough names fit the columns (" + all.length + ")");
  }
  shuffle(all, rng);
  return all.slice(0, LAYOUT.total);
}

function createCase(seed) {
  const rng = mulberry32(seed >>> 0);
  const pairs = makePeople(rng);
  const people = hydrateAll(pairs);
  const killer = people[Math.floor(rng() * people.length)];
  return {
    version: 1,
    seed: seed >>> 0,
    people: pairs,
    killerId: killer.id,
    clues: buildNote(people, killer).map(exportClue),
  };
}

function exportClue(clue) {
  const out = { type: clue.type, text: clue.text };
  for (const key of Object.keys(clue)) {
    if (key === "type" || key === "text") continue;
    out[key] = clue[key];
  }
  return out;
}

function assertCase(state) {
  if (!state || state.version !== 1) throw new Error("Bad case");
  if (!Array.isArray(state.people) || state.people.length !== LAYOUT.total) {
    throw new Error("Bad roster");
  }
  if (!Array.isArray(state.clues) || state.clues.length < 6 || state.clues.length > 6) {
    throw new Error("Bad note");
  }
  const people = hydrateAll(state.people);
  const killer = people[state.killerId];
  if (!killer) throw new Error("Bad guilty id");
  let survivors = 0;
  let survivorId = -1;
  for (const person of people) {
    let ok = true;
    for (const clue of state.clues) {
      if (!matches(clue, person)) {
        ok = false;
        break;
      }
    }
    if (ok) {
      survivors++;
      survivorId = person.id;
    }
  }
  if (survivors !== 1 || survivorId !== killer.id) throw new Error("Note is not unique");
  for (let i = 0; i < state.clues.length; i++) {
    const clue = state.clues[i];
    if (!matches(clue, killer)) throw new Error("Note contradicts itself");
    if (clue.text.includes(killer.name)) throw new Error("Note names the guilty person");
    let extras = 0;
    for (const person of people) {
      if (person.id === killer.id) continue;
      let ok = true;
      for (let c = 0; c < state.clues.length; c++) {
        if (c === i) continue;
        if (!matches(state.clues[c], person)) {
          ok = false;
          break;
        }
      }
      if (ok) extras++;
    }
    if (extras === 0) throw new Error("Redundant clue: " + clue.text);
  }
  return true;
}

function assertAscii(text, label) {
  for (const ch of text) {
    if (ch.charCodeAt(0) > 126) throw new Error(label + " contains a non-ascii character");
  }
}

function runSelfTest() {
  if (SECTIONS.length !== LAYOUT.pages / LAYOUT.pagesPerSection) {
    throw new Error("Section count does not match the page count");
  }
  if (LAYOUT.halfRows !== 20) throw new Error("Column half changed");
  for (const list of [FIRST, LAST, SECTIONS]) {
    if (new Set(list).size !== list.length) throw new Error("Duplicate label in a name list");
  }
  if (FIRST.includes("Alice") || FIRST.includes("Ellen") || LAST.includes("Starling")) {
    throw new Error("Reserved name slipped into the roster lists");
  }
  for (const para of introParagraphs()) assertAscii(para, "intro");
  for (const section of SECTIONS) assertAscii(section, "section");

  const zero = position(0);
  if (zero.page !== 1 || zero.col !== 0 || zero.row !== 0) throw new Error("Origin position");
  const afterColumn = position(LAYOUT.rows);
  if (afterColumn.page !== 1 || afterColumn.col !== 1 || afterColumn.row !== 0) {
    throw new Error("Column break");
  }
  const pageTwo = position(LAYOUT.perPage);
  if (pageTwo.page !== 2 || pageTwo.chapter !== 0) throw new Error("Second page");
  const pageThree = position(LAYOUT.perPage * 2);
  if (pageThree.page !== 3 || pageThree.chapter !== 1) throw new Error("Third page");

  const roster = hydrateAll(createCase(1).people);
  for (const id of [0, 1330, LAYOUT.total - 1]) {
    const edge = {
      version: 1,
      seed: 1,
      people: createCase(1).people,
      killerId: id,
      clues: buildNote(roster, roster[id]),
    };
    assertCase(edge);
  }

  const hist = {};
  const seeds = [];
  for (let seed = 1; seed <= 12; seed++) seeds.push(seed);
  const started = Date.now();
  for (const seed of seeds) {
    const made = createCase(seed);
    assertCase(made);
    const again = createCase(seed);
    if (JSON.stringify(made) !== JSON.stringify(again)) throw new Error("Seed " + seed + " is not stable");
    hist[made.clues.length] = (hist[made.clues.length] || 0) + 1;
    const blob = JSON.stringify(made) + introParagraphs().join(" ") + TITLE;
    if (/alice starling|iris starling|chipping mere|killer isn/i.test(blob)) {
      throw new Error("Reserved wording appeared");
    }
    for (const clue of made.clues) assertAscii(clue.text, "clue");
  }
  const summary =
    "cases " +
    seeds.length +
    " clue counts " +
    JSON.stringify(hist) +
    " ms " +
    (Date.now() - started) +
    " names " +
    LAYOUT.total;
  if (typeof print === "function") print(summary);
  else console.log(summary);
}

globalThis.CaseEngine = {
  TITLE,
  DEK,
  LAYOUT,
  SECTIONS,
  createCase,
  position,
  matches,
  introParagraphs,
  caseLabel,
  widthOf,
  wrapLines,
  assertCase,
};

if (typeof window === "undefined") {
  runSelfTest();
}
